'use client';

import { create } from 'zustand';

interface AchievementSheetState {
  /** Key of the achievement whose detail sheet is open, or null. */
  openKey: string | null;
  open: (key: string) => void;
  close: () => void;
}

/**
 * Drives a single app-level achievement detail sheet (mounted via
 * `GlobalAchievementSheet`). Lets non-screen surfaces — the unlock toast —
 * open the trophy sheet from anywhere without threading props through.
 */
export const useAchievementSheetStore = create<AchievementSheetState>((set) => ({
  openKey: null,
  open: (openKey) => set({ openKey }),
  close: () => set({ openKey: null }),
}));

export const useAchievementSheetKey = () => useAchievementSheetStore((s) => s.openKey);
export const useOpenAchievementSheet = () => useAchievementSheetStore((s) => s.open);
export const useCloseAchievementSheet = () => useAchievementSheetStore((s) => s.close);
